import { getApi } from "@beeldit/core/helpers/api";
import {showSuccessMessage} from "@beeldit/core/helpers/messagesHelper";

function resetPasswordMail(data: any, onSuccess: any, onError: any) {
  const resetMail = async (data: any) => {
    try {
      await getApi().post("/send-reset-password", data);
      showSuccessMessage("successfull_action");
      onSuccess();

    } catch (error) {
      console.error("Error fetching data:", error);
      onError(error);
    }
  };
  resetMail(data);
}

export default resetPasswordMail;

